import * as React from "react";
import { makeStyles, mergeClasses } from "@fluentui/react-components";
import PropTypes from "prop-types";

/* global window */

const useStyles = makeStyles({
  primary: {
    backgroundImage: "linear-gradient(180deg, #8E92E1, #003DAE)",
    boxShadow: "0 0 0 1.5px #003DAE",
    color: "#F5F8FC",
    border: "1px solid #fff3",
    borderRadius: "12px",
    ":hover": {
      backgroundImage: "linear-gradient(180deg, #88CCF8, #003DAE)",
      outline: 0,
    },
    ":hover:disabled": {
      backgroundImage: "none",
    },
    fontSize: "16px",
  },
  normal: {
    border: "1px solid #E5E7EB",
    background: "#fff",
    color: "#525866",
    ":hover": {
      background: "#F5F8FC",
      outline: 0,
    },
    ":hover:disabled": {
      background: "#ccc",
    },
    fontSize: "16px",
  },
  large: {
    padding: "44px 24px",
    fontSize: "18px",
    minWidth: "300px",
  },
  button: {
    flex: 1,
    width: "auto",
    padding: "10px 20px",
    borderRadius: "10px",
    border: "1px solid #ccc",
    cursor: "pointer",
    ":disabled": {
      opacity: 0.5,
      cursor: "not-allowed",
      backgroundImage: "none",
      backgroundColor: "#ccc",
      color: "#666",
      border: "1px solid #999",
      boxShadow: "none",
    },
  },
});

const Button = ({ primary, large, href, onClick, ...props }) => {
  const styles = useStyles();

  const handleClick = (e) => {
    if (href) {
      window.open(href, "_blank");
    }
    if (onClick) {
      onClick(e);
    }
  };

  return (
    <button
      className={mergeClasses(styles.button, primary ? styles.primary : styles.normal, large ? styles.large : "")}
      onClick={handleClick}
      {...props}
    />
  );
};

Button.propTypes = {
  primary: PropTypes.bool,
  large: PropTypes.bool,
  href: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.string,
};

export default Button;
